import request from '@/utils/request'

// 获取比赛详情
export function getCompetitionInfo(data) {
  return request({
    url: 'competition/info',
    method: 'get',
    data
  })
}

// 队员列表 - 已报名
export function getAthleteList(data) {
  return request({
    url: '/quchucai/signup/athlete/list',
    method: 'get',
    data
  })
}

// 创建队伍报名
export function savSignupInfo(data) {
  return request({
    url: 'quchucai/signup/info',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
// 队伍信息查询
export function getSignupInfo(data) {
  return request({
    url: 'quchucai/signup/info',
    method: 'get',
    data
  })
}
// 查询队伍名是否存在
export function lastSignupInfo(data) {
  return request({
    url: 'quchucai/signup/last',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
// 队员列表
export function getSignupeAthletePage(data) {
  return request({
    url: '/quchucai/signup/athlete/page',
    method: 'get',
    data
  })
}

// 报名
export function savtAhleteSave(data) {
  return request({
    url: 'quchucai/signup/athlete/save',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 记录报名阶段
export function signupStage(data) {
  return request({
    url: '/quchucai/signup/stage',
    method: 'post',
    data
  })
}

// 获取已配置教练列表
export function getAthleteFollowerList(data) {
  return request({
    url: '/quchucai/signup/athlete/follower/list',
    method: 'get',
    data
  })
}

// 教练列表
export function getSignupeFollowerPage(data) {
  return request({
    url: '/quchucai/signup/follower/list',
    method: 'get',
    data
  })
}

// 项目配置教练列表
export function getBatchFollowerPage(data) {
  return request({
    url: '/quchucai/signup/batch/follower/list',
    method: 'get',
    data
  })
}

// 批量保存教练
export function saveFollowerBatch(data) {
  return request({
    url: '/quchucai/signup/batch/follower/save',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 教练保存
export function saveSignupFollowerBatch(data) {
  return request({
    url: '/quchucai/signup/athlete/follower/save',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 参赛材料获取
export function getSignUpMaterialList(data) {
  return request({
    url: '/quchucai/signup/material/list',
    method: 'get',
    data
  })
}

// 参赛项目资料
export function getSignUpProjectMaterial(data) {
  return request({
    url: '/quchucai/signup/project/material/list',
    method: 'get',
    type: 'user',
    data
  })
}

// 参赛资料提交
export function saveSignUpMaterial(data) {
  return request({
    url: 'quchucai/signup/material/save',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 项目参赛资料提交
export function saveSignUpProjectMaterial(data) {
  return request({
    url: 'quchucai/signup/project/material/save',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 报名提交
export function submitSignUpInfo(data) {
  return request({
    url: '/signup/quchucai/info',
    method: 'post',
    data
  })
}

// 队伍信息查询
export function getSignUpTitle(data) {
  return request({
    url: 'quchucai/signup/info',
    method: 'get',
    data
  })
}

// 报名记录
export function getSignupPage(data) {
  return request({
    url: '/quchucai/signup/page',
    method: 'get',
    type: 'user',
    data
  })
}

// 取消报名
export function signupCancel(data) {
  return request({
    url: '/quchucai/signup/cancel',
    method: 'get',
    type: 'user',
    data
  })
}

// 删除
export function signupDel(data) {
  return request({
    url: 'quchucai/signup/del',
    method: 'delete',
    type: 'user',
    params: data
  })
}

// 获取队伍名称
export function getLeaderTitle(data) {
  return request({
    url: '/auth/leader/info',
    method: 'get',
    data
  })
}

// 获取我的队伍
export function getAthletelist(data) {
  return request({
    url: '/athlete/group/list',
    method: 'get',
    data
  })
}

// 退出队伍
export function teamDel(data) {
  return request({
    url: '/athlete/group/del',
    method: 'delete',
    type: 'user',
    params: data
  })
}

// 站内信列表
export function getMessageList(data) {
  return request({
    url: '/message/page',
    method: 'get',
    data
  })
}
// 获得荣誉
export function getPrizePage(data) {
  return request({
    url: 'score/prize/page',
    method: 'get',
    data
  })
}

// 站内信未读数量
export function getMessageInfos(data) {
  return request({
    url: '/message/infos',
    method: 'get',
    data
  })
}

// 站内信已读
export function readedMessage(data) {
  return request({
    url: '/message/readed',
    method: 'post',
    data
  })
}

// 人员管理查看成绩
export function getScorePage(data) {
  return request({
    url: '/score/page',
    method: 'get',
    data
  })
}
